import {setLoading} from '../store/slices/loadingIndicatorSlice'
import store from '../store/store'

export const toggleLoading = () => store.dispatch(setLoading())
